<template>
    <v-layout row>
        <v-flex xs12>
            <v-toolbar color="blue-grey">
                <v-toolbar-title>Rules</v-toolbar-title>
            </v-toolbar>
            <v-card>
                <v-card-text>
                    <p>Each challenge has a number of points associated with it ranging from 1 to 10 (mild to wild). To complete a challenge and earn points, you must create a post proving you did what was asked. A post consists of a story (describing your experience) and media (pictures and/or videos). You can redo challenges as many times as you want, earning the associated points with each post.</p>
                    <p>For example, let's say the challenge is getting naked in front of a store and is worth 7 points. You post the following:</p>
                    <v-card color="grey darken-2">
                        <v-card-text>
                            I decided to do this challenge at my local Longs Drugs. Being late morning on a Wednesday, I figured there shouldn't be too may people out. When I got to the parking lot, there were more cars than I expected. I debated about whether to try another challenge, but eventually told myself to just be brave and go for it! Although nervous, I whipped off my long shirt and walked over towards the entrance. As I got close, I saw a car enter the complex out of the corner of my eye. Of course it decided to come way! I just walked back trying to maintain my composure like everything was perfectly normal. I casually put my shirt back on then got into my car. What a rush!
                        </v-card-text>
                        <carousel :nav="false" :margin="10" :autoWidth="true">
                            <v-img
                                v-for="i in 15"
                                :key="i"
                                :src="`img/post/${i}.jpg`"
                                style="width:10em;cursor:pointer;"
                                @click="fullscreenSlide(1, i)"
                            >
                            </v-img>
                        </carousel>
                    </v-card>
                    <br />You would earn 7 points for completing the challenge. If you wish, you could make another post in front of another store to earn 7 more points. Now that scoring is covered, let's go over a few ground rules to keep the game exciting:
                </v-card-text>
                <v-list>
                    <v-list-tile>
                        <v-list-tile-content>
                            You cannot use the same photos and/or videos for multiple challenges and/or posts.
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile>
                        <v-list-tile-content>
                            At least one photo or video segment must adhere to the following:
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
                <v-divider></v-divider>
                <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-content>
                        <div slot="header">Must be 100% fully nude facing camera. All clothing must be removed and cannot be held. Accessories such as shoes, jewelry, sunglasses, or hats are ok.</div>
                        <v-card>
                            <v-card-text>
                                <span class="red--text">No</span>
                                <carousel :nav="false" :margin="10" :autoWidth="true">
                                    <v-img
                                        v-for="i in 11"
                                        :key="i"
                                        :src="`img/rules/no/${i}.jpg`"
                                        style="width:8em;height:8em;cursor:pointer;"
                                        @click="fullscreenSlide(2, i)"
                                    >
                                    </v-img>
                                </carousel>
                                <span class="green--text">Yes</span>
                                <carousel :nav="false" :margin="10" :autoWidth="true">
                                    <v-img
                                        v-for="i in 5"
                                        :key="i"
                                        :src="`img/rules/yes/${i}.jpg`"
                                        style="width:8em;height:8em;cursor:pointer;"
                                        @click="fullscreenSlide(3, i)"
                                    >
                                    </v-img>
                                </carousel>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content>
                        <div slot="header">Cannot be at locations where nudity is established and/or expected. Places or events where nudity is tolerated is ok.</div>
                        <v-card>
                            <v-card-text>
                                <span class="red--text">No</span>
                                <ul class="red--text text--lighten-2">
                                    <li>Resorts (White Tail, Hedonism II, Desire)</li>
                                    <li>Cruises (Bare Necessities, Bliss)</li>
                                    <li>Beaches (Haulover, Black's, Sandy Hook)</li>
                                    <li>Nudist island/city (Île du Levant, Cap d'Agde)</li>
                                </ul>
                                <span class="green--text">Yes</span>
                                <ul class="green--text text--lighten-2">
                                    <li>Events (WNBR, NYC Bodypainting Day, Bay to Breakers)</li>
                                    <li>Parks (Tiergarten, Hippie Hollow)</li>
                                    <li>Outdoors (Deep Creek, Harz)</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content>
                        <div slot="header">Must be public.</div>
                        <v-card>
                            <v-card-text>
                                <span class="red--text">No</span>
                                <ul class="red--text text--lighten-2">
                                    <li>Backyard BBQ</li>
                                    <li>Neighbor's patio</li>
                                </ul>
                                <span class="green--text">Yes</span>
                                <ul class="green--text text--lighten-2">
                                    <li>Hotel balcony</li>
                                    <li>Apartment pool</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-card>
            <fullscreen ref="fullscreen" @change="fullscreenChange" v-show="fullscreen">
                <slider ref="slider1" :options="{loop:true}" v-show="slider1">
                    <slideritem
                        v-for="i in 15"
                        :key="i"
                    >
                        <v-img
                            :src="`img/post/${i}.jpg`"
                            height="100%"
                            :contain="true"
                        />
                    </slideritem>
                </slider>
                <slider ref="slider2" :options="{loop:true}" v-show="slider2">
                    <slideritem
                        v-for="i in 11"
                        :key="i"
                    >
                        <v-img
                            :src="`img/rules/no/${i}.jpg`"
                            height="100%"
                            :contain="true"
                        />
                    </slideritem>
                </slider>
                <slider ref="slider3" :options="{loop:true}" v-show="slider3">
                    <slideritem
                        v-for="i in 5"
                        :key="i"
                    >
                        <v-img
                            :src="`img/rules/yes/${i}.jpg`"
                            height="100%"
                            :contain="true"
                        />
                    </slideritem>
                </slider>
            </fullscreen>
        </v-flex>
    </v-layout>
</template>

<script>
    import carousel from 'v-owl-carousel'
    import fullscreen from 'vue-fullscreen'
    import { slider, slideritem } from 'vue-concise-slider'
    import Vue from 'vue'

    Vue.use(fullscreen)

    export default {
        components: {
            carousel,
            slider,
            slideritem
        },
        data: () => {
            return {
                fullscreen: false,
                slider1: false,
                slider2: false,
                slider3: false,
                sliderIdx: 1,
                slide: 1
            }
        },
        methods: {
            toggle () {
                this.$refs['fullscreen'].toggle();
            },
            fullscreenChange (fullscreen) {
                this.fullscreen = fullscreen;

                if (fullscreen) {
                    window.addEventListener('keyup', this.fullscreenSlideMovement);
                }
                else {
                    window.removeEventListener('keyup', this.fullscreenSlideMovement);
                }
            },
            fullscreenSlide (idx, slide) {
                this.slider1 = false;
                this.slider2 = false;
                this.slider3 = false;
                this.sliderIdx = idx;
                this.slide = --slide;

                this['slider' + this.sliderIdx] = true;

                const me = this;

                setTimeout(() => {
                    me.$refs['slider' + me.sliderIdx].$emit('slideTo', me.slide);
                }, 80);
                
                this.toggle();
            },
            fullscreenSlideMovement (e) {
                if (e.key == 'ArrowLeft') {
                    this.$refs['slider' + this.sliderIdx].$emit('slidePre');
                }
                
                if (e.key == 'ArrowRight') {
                    this.$refs['slider' + this.sliderIdx].$emit('slideNext');
                }
            }
        }
    }
</script>